
import moment from 'moment';
import qs from 'qs';

import React, { Component}  from 'react';

import { FormProvider, FormContext } from 'core/FormProvider';
import Layout  from 'components/Dashboard/Layout';
import { UserContext } from 'components/User';
import { PreloadOrder } from './PreloadOrder';
import FormDialogWrapper from "./FormConfigmDialog";


export default class OrderAdd extends Component {

  static contextType = UserContext;

  static defaultProps = {
    apiUrl: 'order',
    basePath: '/order',
    documentTitle: 'Новая перевозка',
    headerTitle: 'Создание перевозки',
    extraItem: {},
  };

  componentDidMount() {
    document.title = this.props.documentTitle;
  }

  onDetail = (item) => {
    this.props.history.push(this.props.basePath);
  };

  render() {
    const { match, history, apiUrl, basePath, headerTitle, extraItem } = this.props;
    let dateStart = moment();
    const params = qs.parse(history.location.search.substr(1));
    if (params.date_start) {
      dateStart = moment(params.date_start);
    }

    return (
      <FormProvider
        url={apiUrl}
        postSave={(item) => this.onDetail(item)}
        item={{
          department: this.context.data.department_active,
          date_start: dateStart.format('YYYY-MM-DD HH:mm'),
          contact_persons: [],
          points: [
            {
              position: 1,
              services: []
            }
          ],
          extra_services: [],
          schedule: null,
          ...extraItem,
        }}
      >
        <FormContext.Consumer>
        {context => {
          return (
            <PreloadOrder id={match.params.id} onUpdate={context.setValues} apiUrl={apiUrl}>
              <Layout>

                <Layout.Header
                  title={headerTitle}
                  backUrl={basePath}
                />

                <Layout.ContentSimple>

                  <FormDialogWrapper
                    formContext={context}
                    buttonLabel={'Создать перевозку'}
                  />

                </Layout.ContentSimple>
              </Layout>
            </PreloadOrder>
          )
        }}
        </FormContext.Consumer>
      </FormProvider>
    )
  }
}
